import { render, staticRenderFns } from "./LoginRequestDialog.vue?vue&type=template&id=5aa96a28&scoped=true"
import script from "./LoginRequestDialog.vue?vue&type=script&lang=ts"
export * from "./LoginRequestDialog.vue?vue&type=script&lang=ts"
import style0 from "./LoginRequestDialog.vue?vue&type=style&index=0&id=5aa96a28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa96a28",
  null
  
)

export default component.exports